import { Box, styled } from '@mui/material';

import { ImageTranscriptComponent } from './types';

export const ImageStep = ({
  transcriptComponent,
}: {
  transcriptComponent: ImageTranscriptComponent;
}) => {
  return (
    <Container>
      <AspectRatioBox>
        <Box
          alt={transcriptComponent.description}
          component='img'
          src={decodeURIComponent(transcriptComponent.url)}
          sx={{
            border: '1px solid rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            height: '100%',
            objectFit: 'contain',
            width: '100%',
          }}
        />
      </AspectRatioBox>
    </Container>
  );
};

// eslint-disable-next-line react-refresh/only-export-components -- TODO: fix later
export const Container = styled('div')`
  background-color: transparent;
  margin-left: 4px;
`;

// eslint-disable-next-line react-refresh/only-export-components -- TODO: fix later
export const AspectRatioBox = styled('div')`
  aspect-ratio: 16 / 9;
  width: 100%;
  position: relative;
`;
